import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import whiteLogo from "../../assets/white-logo.png";
import LogoutButton from "../dashboard/LogoutButton";
import "./SideBarV2.css";
import sendServerLogging from "../../utils/sendServerLogging";
import userJSON from "../../utils/userJSON";


export default function SideBar({ setAuth, isOpen, onClose }) {
  const currentPath = useLocation().pathname;

  const navigate = useNavigate();

  const redirectToDashboard = () => {
            //server logging
            sendServerLogging({
              body: {
                ...userJSON(localStorage.getItem("userName")),
                event: "NAVIGATE_DASHBOARD",
                eventData: {},
              },
            });
    navigate("/dashboard");
  };

  const redirectToAllNotes = () => {
    //server logging
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "NAVIGATE_ALL_NOTES",
        eventData: {},
      },
    });
    navigate("/notes");
  };

  const redirectToHome = () => {
    //server logging
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "NAVIGATE_HOME",
        eventData: {},
      },
    });
    navigate("/");
  };

  const redirectToSettings = () => {
    //server logging
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "NAVIGATE_SETTINGS",
        eventData: {},
      },
    });
    navigate("/settings");
  };

  const redirectToHelpCenter = (url, e) => {
    //server logging
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "NAVIGATE_HELP_CENTER",
        eventData: {},
      },
    });
    e.preventDefault();
  
    window.open(url, "_blank");
  };

  return (
    <div
      className={`fixed flex flex-col justify-between items-center h-screen z-0 inset-0 bg-accent2 text-white transition-transform transform ${
        isOpen
          ? "translate-x-0 z-10 w-screen"
          : "w-side-bar-w -translate-x-full z-10"
      } desktop:translate-x-0 overflow-y-auto`}
    >
      {isOpen ? (
        <button
          onClick={onClose}
          className="absolute z-50 top-4 right-4 text-2xl"
        >
          &times;
        </button>
      ) : null}
      <div>
        <a
          href="/"
          className="flex justify-center items-center mx-2 mt-10"
          onClick={redirectToHome}
          data-testid="knowtex-logo-link"
        >
          <img
            src={whiteLogo}
            className="w-[50%] desktop:w-[90%]"
            alt="Knowtex Logo"
          />
        </a>
      </div>
      <ul className="flex flex-col justify-between h-[45%] items-center mt-4 p-4">
        <li className="block px-4 py-2">
          {currentPath === "/dashboard" ? (
            <button
              href="#"
              className="flex items-center p-2 text-background1 rounded-lg hover:text-background1 "
              onClick={redirectToDashboard}
              data-testid="dashboard-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-5 w-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
                />
              </svg>
              <span className="ms-3 text-lg desktop:text-2xl laptop:text-xl">
                Dashboard
              </span>
            </button>
          ) : (
            <button
              href="#"
              className="flex items-center p-2 text-secondary-text-grey rounded-lg hover:text-background1 "
              onClick={redirectToDashboard}
              data-testid="dashboard-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-5 w-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
                />
              </svg>
              <span className="ms-3 text-lg desktop:text-2xl laptop:text-xl">
                Dashboard
              </span>
            </button>
          )}
        </li>
        <li className="block px-4 py-2">
          {currentPath === "/notes" ? (
            <button
              href="#"
              className="flex items-center p-2 text-background1 rounded-lg hover:text-background1"
              onClick={redirectToAllNotes}
              data-testid="all-notes-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-5 w-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
                />
              </svg>
              <span className="ms-3 text-lg desktop:text-2xl laptop:text-xl">
                All Notes
              </span>
            </button>
          ) : (
            <button
              href="#"
              className="flex items-center p-2 text-secondary-text-grey rounded-lg hover:text-background1"
              onClick={redirectToAllNotes}
              data-testid="all-notes-link"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-5 w-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
                />
              </svg>
              <span className="ms-3 text-lg desktop:text-2xl laptop:text-xl">
                All Notes
              </span>
            </button>
          )}
        </li>
        <li className="block px-4 py-2">
          <button
            href="https://atlas-kb.com/knowtex"
            className="flex items-center p-2 text-secondary-text-grey rounded-lg hover:text-background1"
            onClick={(e) =>
              redirectToHelpCenter("https://atlas-kb.com/knowtex", e)
            }
            data-testid="help-center"
          >
            <svg
              className="h-5 w-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M7.529 7.988a2.502 2.502 0 0 1 5 .191A2.441 2.441 0 0 1 10 10.582V12m-.01 3.008H10M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <span className="ms-3 text-lg desktop:text-2xl laptop:text-xl">
              Help Center
            </span>
          </button>
        </li>
        <li className="block px-4 py-2">
          {currentPath === "/settings" ? (
            <button
              href="#"
              className="flex items-center p-2 text-background1 rounded-lg hover:text-background1"
              onClick={redirectToSettings}
              data-testid="all-notes-link"
            >
              <svg
                className="h-5 w-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 22 22"
              >
                <g id="SVGRepo_iconCarrier">
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></circle>{" "}
                  <path
                    d="M3.66122 10.6392C4.13377 10.9361 4.43782 11.4419 4.43782 11.9999C4.43781 12.558 4.13376 13.0638 3.66122 13.3607C3.33966 13.5627 3.13248 13.7242 2.98508 13.9163C2.66217 14.3372 2.51966 14.869 2.5889 15.3949C2.64082 15.7893 2.87379 16.1928 3.33973 16.9999C3.80568 17.8069 4.03865 18.2104 4.35426 18.4526C4.77508 18.7755 5.30694 18.918 5.83284 18.8488C6.07287 18.8172 6.31628 18.7185 6.65196 18.5411C7.14544 18.2803 7.73558 18.2699 8.21895 18.549C8.70227 18.8281 8.98827 19.3443 9.00912 19.902C9.02332 20.2815 9.05958 20.5417 9.15224 20.7654C9.35523 21.2554 9.74458 21.6448 10.2346 21.8478C10.6022 22 11.0681 22 12 22C12.9319 22 13.3978 22 13.7654 21.8478C14.2554 21.6448 14.6448 21.2554 14.8478 20.7654C14.9404 20.5417 14.9767 20.2815 14.9909 19.9021C15.0117 19.3443 15.2977 18.8281 15.7811 18.549C16.2644 18.27 16.8545 18.2804 17.3479 18.5412C17.6837 18.7186 17.9271 18.8173 18.1671 18.8489C18.693 18.9182 19.2249 18.7756 19.6457 18.4527C19.9613 18.2106 20.1943 17.807 20.6603 17C20.8677 16.6407 21.029 16.3614 21.1486 16.1272M20.3387 13.3608C19.8662 13.0639 19.5622 12.5581 19.5621 12.0001C19.5621 11.442 19.8662 10.9361 20.3387 10.6392C20.6603 10.4372 20.8674 10.2757 21.0148 10.0836C21.3377 9.66278 21.4802 9.13092 21.411 8.60502C21.3591 8.2106 21.1261 7.80708 20.6601 7.00005C20.1942 6.19301 19.9612 5.7895 19.6456 5.54732C19.2248 5.22441 18.6929 5.0819 18.167 5.15113C17.927 5.18274 17.6836 5.2814 17.3479 5.45883C16.8544 5.71964 16.2643 5.73004 15.781 5.45096C15.2977 5.1719 15.0117 4.6557 14.9909 4.09803C14.9767 3.71852 14.9404 3.45835 14.8478 3.23463C14.6448 2.74458 14.2554 2.35523 13.7654 2.15224C13.3978 2 12.9319 2 12 2C11.0681 2 10.6022 2 10.2346 2.15224C9.74458 2.35523 9.35523 2.74458 9.15224 3.23463C9.05958 3.45833 9.02332 3.71848 9.00912 4.09794C8.98826 4.65566 8.70225 5.17191 8.21891 5.45096C7.73557 5.73002 7.14548 5.71959 6.65205 5.4588C6.31633 5.28136 6.0729 5.18269 5.83285 5.15108C5.30695 5.08185 4.77509 5.22436 4.35427 5.54727C4.03866 5.78945 3.80569 6.19297 3.33974 7C3.13231 7.35929 2.97105 7.63859 2.85138 7.87273"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                </g>
              </svg>
              <span className="ms-3 text-lg desktop:text-2xl laptop:text-xl">
                Settings
              </span>
            </button>
          ) : (
            <button
              href="#"
              className="flex items-center p-2 text-secondary-text-grey rounded-lg hover:text-background1"
              onClick={redirectToSettings}
              data-testid="all-notes-link"
            >
              <svg
                className="h-5 w-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 22 22"
              >
                <g id="SVGRepo_iconCarrier">
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></circle>{" "}
                  <path
                    d="M3.66122 10.6392C4.13377 10.9361 4.43782 11.4419 4.43782 11.9999C4.43781 12.558 4.13376 13.0638 3.66122 13.3607C3.33966 13.5627 3.13248 13.7242 2.98508 13.9163C2.66217 14.3372 2.51966 14.869 2.5889 15.3949C2.64082 15.7893 2.87379 16.1928 3.33973 16.9999C3.80568 17.8069 4.03865 18.2104 4.35426 18.4526C4.77508 18.7755 5.30694 18.918 5.83284 18.8488C6.07287 18.8172 6.31628 18.7185 6.65196 18.5411C7.14544 18.2803 7.73558 18.2699 8.21895 18.549C8.70227 18.8281 8.98827 19.3443 9.00912 19.902C9.02332 20.2815 9.05958 20.5417 9.15224 20.7654C9.35523 21.2554 9.74458 21.6448 10.2346 21.8478C10.6022 22 11.0681 22 12 22C12.9319 22 13.3978 22 13.7654 21.8478C14.2554 21.6448 14.6448 21.2554 14.8478 20.7654C14.9404 20.5417 14.9767 20.2815 14.9909 19.9021C15.0117 19.3443 15.2977 18.8281 15.7811 18.549C16.2644 18.27 16.8545 18.2804 17.3479 18.5412C17.6837 18.7186 17.9271 18.8173 18.1671 18.8489C18.693 18.9182 19.2249 18.7756 19.6457 18.4527C19.9613 18.2106 20.1943 17.807 20.6603 17C20.8677 16.6407 21.029 16.3614 21.1486 16.1272M20.3387 13.3608C19.8662 13.0639 19.5622 12.5581 19.5621 12.0001C19.5621 11.442 19.8662 10.9361 20.3387 10.6392C20.6603 10.4372 20.8674 10.2757 21.0148 10.0836C21.3377 9.66278 21.4802 9.13092 21.411 8.60502C21.3591 8.2106 21.1261 7.80708 20.6601 7.00005C20.1942 6.19301 19.9612 5.7895 19.6456 5.54732C19.2248 5.22441 18.6929 5.0819 18.167 5.15113C17.927 5.18274 17.6836 5.2814 17.3479 5.45883C16.8544 5.71964 16.2643 5.73004 15.781 5.45096C15.2977 5.1719 15.0117 4.6557 14.9909 4.09803C14.9767 3.71852 14.9404 3.45835 14.8478 3.23463C14.6448 2.74458 14.2554 2.35523 13.7654 2.15224C13.3978 2 12.9319 2 12 2C11.0681 2 10.6022 2 10.2346 2.15224C9.74458 2.35523 9.35523 2.74458 9.15224 3.23463C9.05958 3.45833 9.02332 3.71848 9.00912 4.09794C8.98826 4.65566 8.70225 5.17191 8.21891 5.45096C7.73557 5.73002 7.14548 5.71959 6.65205 5.4588C6.31633 5.28136 6.0729 5.18269 5.83285 5.15108C5.30695 5.08185 4.77509 5.22436 4.35427 5.54727C4.03866 5.78945 3.80569 6.19297 3.33974 7C3.13231 7.35929 2.97105 7.63859 2.85138 7.87273"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  ></path>
                </g>
              </svg>
              <span className="ms-3 text-lg desktop:text-2xl laptop:text-xl">
                Settings
              </span>
            </button>
          )}
        </li>
        <li className="block px-4 py-2">
          <div className="flex items-center p-2 text-secondary-text-grey rounded-lg group hover:text-background1">
            <svg
              className="h-5 w-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 18"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 5h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2v3l-4-3H8m4-13H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2v3l4-3h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Z"
              />
            </svg>
            <button
              className="items-center text-secondary-text-grey rounded-lg hover:text-background1 ms-3 text-lg desktop:text-2xl laptop:text-xl"
              data-testid="contact-us"
              onClick={() => {
                window.Atlas.chat.openWindow();
              }}
            >
              Contact Us
            </button>
          </div>
        </li>
      </ul>
      <div className="flex w-[50%] desktop:w-[100%]">
        <LogoutButton setAuth={setAuth} />
      </div>
    </div>
  );
}
